// extracted by mini-css-extract-plugin
module.exports = {"footer":"_842e390","button":"_f441885"};